import './assets/css/App.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import Dashboard from './layouts/admin';
import { ChakraProvider } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState, useEffect } from 'react';
import routes from 'routes.js';
import Cookies from 'js-cookie';
import ModbusConfigs from 'views/admin/modbusConfigs/ModbusConfigs';
import { DeviceProvider } from 'views/admin/context/DeviceContext';

const isUserLoggedIn = () => !!Cookies.get('authToken');

export default function Main() {
  const [currentTheme] = useState(initialTheme);

  const [isAuthenticated, setIsAuthenticated] = useState(isUserLoggedIn());
  const location = useLocation();

  useEffect(() => {
    // Debug: log auth + location to help trace redirects on refresh.
    // eslint-disable-next-line no-console
    // console.log(
    //   '[App] location',
    //   location.pathname,
    //   'isAuthenticated',
    //   isUserLoggedIn(),
    // );
  }, [location.pathname]);

  useEffect(() => {
    setIsAuthenticated(isUserLoggedIn());
  }, [location.pathname]);

  const authRoutes = routes.filter((r) => r.layout === '/auth');

  return (
    <DeviceProvider>
      <ChakraProvider theme={currentTheme}>
        <Routes>
          {/* Auth Routes */}
          <Route
            path="/auth/*"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <AuthLayout />
              )
            }
          >
            {authRoutes.map((route, i) => (
              <Route
                key={i}
                path={route.path.replace('/sign-in', 'sign-in')}
                element={route.component}
              />
            ))}
          </Route>

          {/* Admin Layout */}
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <Dashboard />
              ) : (
                <Navigate to="/auth/sign-in" replace />
              )
            }
          />
        </Routes>
      </ChakraProvider>
    </DeviceProvider>
  );
}
